import { salonDateISO } from './salonDate';

const DATE_PREFIX = /^(\d{4}-\d{2}-\d{2})(?:$|[T ])/;
const HAS_ZONE = /(?:Z|[+-]\d{2}:?\d{2})$/i;

// DaySmart wall times have no zone; the date prefix is the Chicago calendar day.
// Instants with Z or an offset are converted to America/Chicago.
export function appointmentSalonDay(value) {
    if (value === undefined || value === null || value === '') return '';
    const text = String(value).trim();
    const prefix = text.match(DATE_PREFIX);
    if (prefix && !HAS_ZONE.test(text)) return prefix[1];
    const parsed = new Date(text);
    if (Number.isNaN(parsed.getTime())) return '';
    return salonDateISO(parsed);
}

export function isAfterSelectedSalonDay(value, selectedDate) {
    const day = appointmentSalonDay(value);
    const selected = String(selectedDate || '').trim().slice(0, 10);
    if (!day || !/^\d{4}-\d{2}-\d{2}$/.test(selected)) return false;
    return day > selected;
}

export function appointmentsAfterSelectedDay(appointments, selectedDate) {
    if (!Array.isArray(appointments)) return [];
    return appointments.filter((appointment) => isAfterSelectedSalonDay(
        appointment?.start_time || appointment?.date_scheduled,
        selectedDate
    ));
}

export function upcomingVisitCount(appointments, selectedDate) {
    const days = new Set();
    appointmentsAfterSelectedDay(appointments, selectedDate).forEach((appointment) => {
        const day = appointmentSalonDay(appointment?.start_time || appointment?.date_scheduled);
        if (day) days.add(day);
    });
    return days.size;
}

export function buildUpcomingEmailBody(appointmentLines, signature) {
    if (appointmentLines) {
        return `Hello,

Here are your upcoming appointments at Zoom Groom:
${appointmentLines}
${signature}`;
    }
    return `Hello,

We noticed you don't have any upcoming appointments scheduled at Zoom Groom. We'd love to see you and your pet(s) again soon!

Please give us a call or book online to schedule your next visit.
${signature}`;
}
